<script setup lang="ts">
import { computed } from 'vue'
import type { SystemEvent } from '../../api/types'
import { clockTime } from '../../lib/inbox'
import { systemLineParts } from '../../lib/routing'
import { BLOCK_CLOSE_REASON } from '../../lib/wcblock'
import Icon from '../ui/Icon.vue'

const props = defineProps<{ item: SystemEvent }>()

// "แจกอัตโนมัติให้ พลอย · ยุ่งน้อยสุด" · "ย้ายแชทให้ จิต" · "ปิดอัตโนมัติ · ลูกค้าเงียบ 30 นาที" ·
// "เปิดแชทอีกครั้ง · ลูกค้าทักกลับมา" · "AI ส่งต่อให้ พลอย เพราะ…" (lib/routing.ts systemLineParts)
const parts = computed(() => systemLineParts(props.item))
const icon = computed(() => {
  switch (props.item.event) {
    case 'assigned':
      return 'users' as const
    case 'closed':
      // closed because staff blocked the sender (web chat): the block's shield, not a routine tick
      return props.item.reason === BLOCK_CLOSE_REASON ? ('shield' as const) : ('check' as const)
    case 'reopened':
      return 'repeat' as const
    case 'requeued':
      return 'inbox' as const
    case 'follow_up':
      return 'history' as const
    case 'ai_on':
      return 'sparkles' as const
    case 'ai_off':
      return 'pauseCircle' as const
  }
  return 'handoff' as const
})
</script>

<template>
  <div class="sys">
    <div class="sys-pill" :class="{ routine: item.event !== 'ai_handoff' }">
      <Icon :name="icon" />
      <span
        >{{ parts.lead }}<template v-if="parts.staff">{{ ' ' }}<b>{{ parts.staff }}</b></template
        >{{ parts.tail }}</span
      >
      <span class="mono sys-t">{{ clockTime(item.at) }}</span>
    </div>
  </div>
</template>

<style scoped>
.sys {
  display: flex;
  justify-content: center;
}
.sys-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: 100%;
  padding: 6px 12px;
  border-radius: 10px;
  background: #fff6e0;
  border: 1px solid #f0dca6;
  color: #6b4300;
  font-size: 12.5px;
  line-height: 20px;
}
.sys-pill :deep(.ic) {
  width: 15px;
  height: 15px;
}
.sys-pill b {
  font-weight: 600;
}
/* routine lines (assigned / closed / reopened) are calmer than an AI hand-off */
.sys-pill.routine {
  background: #f3f6f4;
  border-color: var(--line);
  color: #3e4d46;
}
.sys-pill.routine .sys-t {
  color: var(--mut);
}
.sys-t {
  color: #7a5a1e;
  font-size: 12px;
  white-space: nowrap;
}
</style>
